import * as i0 from '@angular/core';
import { input, computed, Component } from '@angular/core';
import { GhostStateFragmentDirective } from '@futura/futura-ui/ghost';
import { NgClass, NgTemplateOutlet } from '@angular/common';
const _c0 = (a0, a1) => [a0, a1];
function PodiumComponent_div_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 5)(1, "rect", 6)(2, "path", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.type());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.type());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.type());
  }
}
function PodiumComponent_div_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 3);
  }
}
function PodiumComponent_div_0_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", ctx, " ");
  }
}
function PodiumComponent_div_0_Conditional_4_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PodiumComponent_div_0_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PodiumComponent_div_0_Conditional_4_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngTemplateOutlet", ctx);
  }
}
function PodiumComponent_div_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, PodiumComponent_div_0_Conditional_4_Conditional_1_Template, 1, 1)(2, PodiumComponent_div_0_Conditional_4_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0, ctx_r0.type(), ctx_r0.dashed() ? "dashed" : ""));
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = ctx_r0.textString()) ? 1 : -1, tmp_3_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_4_0 = ctx_r0.textTemplate()) ? 2 : -1, tmp_4_0);
  }
}
function PodiumComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 2);
    i0.ɵɵtemplate(2, PodiumComponent_div_0_Conditional_2_Template, 3, 3)(3, PodiumComponent_div_0_Conditional_3_Template, 1, 0, ":svg:path", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PodiumComponent_div_0_Conditional_4_Template, 3, 6, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.dashed() ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.text() ? 4 : -1);
  }
}
let PodiumComponent = /*#__PURE__*/(() => {
  class PodiumComponent {
    constructor() {
      this.state = input();
      this.type = input('primary');
      this.dashed = input(false);
      this.text = input();
      this.textString = computed(() => {
        const text = this.text();
        if (typeof text !== 'string') {
          return null;
        }
        return text;
      });
      this.textTemplate = computed(() => {
        const text = this.text();
        if (!text || typeof text === 'string') {
          return null;
        }
        return text;
      });
    }
    static {
      this.ɵfac = function PodiumComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PodiumComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PodiumComponent,
        selectors: [["fut-podium"]],
        inputs: {
          state: [1, "state"],
          type: [1, "type"],
          dashed: [1, "dashed"],
          text: [1, "text"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        consts: [["class", "position-relative podium-container", 4, "futGhostStateFragment", "futGhostStateFragmentText"], [1, "position-relative", "podium-container"], ["xmlns", "http://www.w3.org/2000/svg", "width", "53", "height", "41", "viewBox", "0 0 53 41", "fill", "none"], ["d", "M20.2081 4.00584C23.4907 1.79348 28.8189 1.78429 32.109 3.98532L46.4064 13.5501C49.6965 15.7511 49.7026 19.3289 46.4201 21.5412L32.1555 31.1553C28.8729 33.3676 23.5448 33.3768 20.2547 31.1758L5.95724 21.611C2.66714 19.41 2.66101 15.8322 5.94356 13.6198L20.2081 4.00584Z", "fill", "white", "stroke-dasharray", "4 4", 1, "podium-dashed"], [1, "position-absolute", "text-container", 3, "ngClass"], ["d", "M20.2081 9.75389C23.4907 7.54152 28.8189 7.53233 32.109 9.73337L46.4064 19.2981C49.6965 21.4992 49.7026 25.0769 46.4201 27.2893L32.1555 36.9033C28.8729 39.1157 23.5448 39.1248 20.2547 36.9238L5.95724 27.3591C2.66714 25.158 2.66101 21.5803 5.94356 19.3679L20.2081 9.75389Z", 1, "podium-back", 3, "ngClass"], ["x", "3.50641", "y", "17.5371", "width", "45.3786", "height", "5.74771", 1, "podium-back", 3, "ngClass"], ["d", "M20.2081 4.00584C23.4907 1.79348 28.8189 1.78429 32.109 3.98532L46.4064 13.5501C49.6965 15.7511 49.7026 19.3289 46.4201 21.5412L32.1555 31.1553C28.8729 33.3676 23.5448 33.3768 20.2547 31.1758L5.95724 21.611C2.66714 19.41 2.66101 15.8322 5.94356 13.6198L20.2081 4.00584Z", 1, "podium-front", 3, "ngClass"], [4, "ngTemplateOutlet"]],
        template: function PodiumComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PodiumComponent_div_0_Template, 5, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("futGhostStateFragment", ctx.state())("futGhostStateFragmentText", "000");
          }
        },
        dependencies: [GhostStateFragmentDirective, NgClass, NgTemplateOutlet],
        styles: [".podium-container[_ngcontent-%COMP%]{width:min-content}.podium-container[_ngcontent-%COMP%]   .podium-front[_ngcontent-%COMP%]{fill:var(--podium-front, transparent)}.podium-container[_ngcontent-%COMP%]   .podium-front.primary[_ngcontent-%COMP%]{--podium-front: var(--fut-primary-200)}.podium-container[_ngcontent-%COMP%]   .podium-front.secondary[_ngcontent-%COMP%]{--podium-front: var(--fut-secondary-800)}.podium-container[_ngcontent-%COMP%]   .podium-front.light[_ngcontent-%COMP%], .podium-container[_ngcontent-%COMP%]   .podium-front.light-secondary[_ngcontent-%COMP%]{--podium-front: var(--fut-secondary-100)}.podium-container[_ngcontent-%COMP%]   .podium-back[_ngcontent-%COMP%]{fill:var(--podium-back, transparent)}.podium-container[_ngcontent-%COMP%]   .podium-back.primary[_ngcontent-%COMP%]{--podium-back: var(--fut-primary-300)}.podium-container[_ngcontent-%COMP%]   .podium-back.secondary[_ngcontent-%COMP%]{--podium-back: var(--fut-secondary-900)}.podium-container[_ngcontent-%COMP%]   .podium-back.light[_ngcontent-%COMP%], .podium-container[_ngcontent-%COMP%]   .podium-back.light-secondary[_ngcontent-%COMP%]{--podium-back: var(--fut-secondary-400)}.podium-container[_ngcontent-%COMP%]   .podium-dashed[_ngcontent-%COMP%]{stroke:var(--fut-secondary-500)}.podium-container[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]{top:50%;transform:translate(50%,-50%);right:50%;color:var(--text-color, transparent)}.podium-container[_ngcontent-%COMP%]   .text-container.primary[_ngcontent-%COMP%], .podium-container[_ngcontent-%COMP%]   .text-container.secondary[_ngcontent-%COMP%]{--text-color: var(--fut-white)}.podium-container[_ngcontent-%COMP%]   .text-container.light[_ngcontent-%COMP%]{--text-color: var(--fut-primary-500)}.podium-container[_ngcontent-%COMP%]   .text-container.light.dashed[_ngcontent-%COMP%], .podium-container[_ngcontent-%COMP%]   .text-container.light-secondary[_ngcontent-%COMP%], .podium-container[_ngcontent-%COMP%]   .text-container.light-secondary.dashed[_ngcontent-%COMP%]{--text-color: var(--fut-secondary-500)}"]
      });
    }
  }
  return PodiumComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PodiumComponent };
